import locales from '../../../constants/commonLocales';

import WithFormLayout, { Props as FormLayoutProps } from '../with-form-layout';

interface Props extends Omit<FormLayoutProps, 'closeLabel' | 'submitLabel' | 'formInfoText'> {
  filtersChanged: boolean;
}

const WithFilterFormLayout = ({ children, onSecondary, onSubmit, loading, filtersChanged }: Props) => (
  <WithFormLayout
    formInfoText="Select table filters"
    onSecondary={onSecondary}
    onSubmit={onSubmit}
    secondaryLabel={filtersChanged ? locales.form.button.remove : locales.form.button.close}
    submitLabel={locales.form.button.apply}
    loading={loading}
  >
    {children}
  </WithFormLayout>
);

export default WithFilterFormLayout;
